import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const forgotPassword = (params) => {
  return function () {
    return AssessmentServiceApi.forgotPassword(params)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { forgotPassword };
